/*  iceberg-ui  */
import { IconWithVariant } from '@auviknetworks/iceberg-ui';
import { Box } from '@mui/material';

/*  Shared  */
import { SessionHelper } from 'application/Shared/Helpers';

/*  Objects  */
import { User, UserFromContext } from 'objects/User';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class Owner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            tenantName: ''
        };
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        const { session, tenant } = this.props;

        const sessionHelper = new SessionHelper(session);
        let tenantName = sessionHelper.getTenantName();

        if (tenant && tenant.name) {
            tenantName = tenant.name;
        }

        this.setState({ loaded: true, tenantName });
    };

    renderUser = () => {
        const {
            application,
            businessOwnerPlatformUserId,
            errorFn,
            t,
            useTenantName
        } = this.props;
        const { loaded, tenantName } = this.state;

        if (!loaded || !application) {
            return null;
        }

        const id =
            businessOwnerPlatformUserId ||
            application.businessOwnerPlatformUserId;

        if (id) {
            return (
                <User errorFn={() => errorFn} id={id}>
                    <UserFromContext link />
                </User>
            );
        }

        if (useTenantName && tenantName) {
            return (
                <Box
                    display="flex"
                    alignItems="center"
                    data-trackid="ownerRenderUserUseTenantNameTenantName"
                >
                    {/* 22px to match the 24px of the avatars */}
                    <IconWithVariant
                        variant="primary"
                        src="Domain"
                        size="22px"
                        wrapperProps={{ width: '32px' }}
                    />
                    <Box flex={1}>{tenantName}</Box>
                </Box>
            );
        }

        return (
            <Box
                display="flex"
                alignItems="center"
                data-trackid="ownerRenderUserNoUseTenantNameNoTenantName"
            >
                {/* 26px to match the 24px of the avatars */}
                <IconWithVariant
                    variant="danger"
                    src="CloseCircle"
                    size="26px"
                    wrapperProps={{ width: '32px' }}
                />
                <Box flex={1}>{t('Common.not_assigned')}</Box>
            </Box>
        );
    };

    render() {
        const {
            application,
            managed3rdParty,
            managedByPartner,
            noBusinessOwnerRequired,
            t
        } = this.props;

        if (noBusinessOwnerRequired || application.noBusinessOwnerRequired) {
            return (
                <Box
                    display="flex"
                    alignItems="center"
                    data-trackid="ownerNoBusinessOwnerRequired"
                >
                    {/* 26px to match the 24px of the avatars */}
                    <IconWithVariant
                        variant="tertiary"
                        src="CheckCircle"
                        size="26px"
                        wrapperProps={{ width: '32px' }}
                    />
                    <Box flex={1}>{t('Common.not_required')}</Box>
                </Box>
            );
        }

        if (managedByPartner || application.managedByPartner) {
            return (
                <Box
                    display="flex"
                    alignItems="center"
                    data-trackid="ownerManagedByPartner"
                >
                    {/* 26px to match the 24px of the avatars */}
                    <IconWithVariant
                        variant="secondary"
                        src="GroupCircle"
                        size="26px"
                        wrapperProps={{ width: '32px' }}
                    />
                    <Box flex={1}>{t('Common.managed_by_partner')}</Box>
                </Box>
            );
        }

        if (managed3rdParty || application.managed3rdParty) {
            return (
                <Box
                    display="flex"
                    alignItems="center"
                    data-trackid="ownerManagedBy3rdParty"
                >
                    {/* 26px to match the 24px of the avatars */}
                    <IconWithVariant
                        variant="infoDark"
                        src="BlurCircular"
                        size="26px"
                        wrapperProps={{ width: '32px' }}
                    />
                    <Box flex={1}>{t('Common.managed_by_3rd_party')}</Box>
                </Box>
            );
        }

        return this.renderUser();
    }
}

export default withTranslation()(Owner);
